import { Routes, Route, Navigate } from "react-router-dom"

import { CircularProgress } from "@mui/material"
import { useAuth0 } from "@equipmentshare/auth0-react"
import { useFlags } from "@equipmentshare/feature-flags"

import { ROUTE_PATHS } from "@app/const/RoutePaths"
import { LastCreated } from "@app/pages/last-created/LastCreated"
import { LabelGenerator } from "@app/pages/label-generator/LabelGenerator"
import { Layout } from "./pages/Layout"
import { HeaperInit } from "./integrations/heaper"

export const AppRoutes: React.FC = () => {
	const { isLoading } = useAuth0()
	const { enableBulkLabelGeneratorLastCreated } = useFlags()

	return isLoading ? (
		<div
			style={{
				display: "grid",
				placeItems: "center center",
				width: "100vw",
				height: "100vh",
			}}
		>
			<CircularProgress size="3rem" />
		</div>
	) : (
		<>
			<HeaperInit />
			<Routes>
				<Route path={ROUTE_PATHS.HOME.path} element={<Layout />}>
					<Route index element={<Navigate to={ROUTE_PATHS.LABEL_GENERATOR.path} />} />
					<Route path={ROUTE_PATHS.LABEL_GENERATOR.path} element={<LabelGenerator />} />
					{enableBulkLabelGeneratorLastCreated && (
						<Route path={ROUTE_PATHS.LAST_CREATED.path} element={<LastCreated />} />
					)}
				</Route>
			</Routes>
		</>
	)
}
